import React, { useCallback, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { Icon } from '@core/js/components/common/Icon';

import Overlay from '@interlayer/js/components/common/Overlay/Overlay';

import { GamesSearchGlobal } from '@theme/js/custom/components/main/GameSearchGlobal/GameSearchGlobal';

import style from './StickySearch.scss';

export const StickySearch: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handlerCloseGamesSearch = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handlerOpenGamesSearch = () => {
        dispatcher.dispatch('menu:action:close');
        setIsOpen(true);
    };

    return (
        <>
            <Icon
                type="search"
                className={style.searchIcon}
                onClick={handlerOpenGamesSearch}
            />

            {isOpen && (
                <div className={style.searchBlock}>
                    <Overlay className={style.overlay} onClick={handlerCloseGamesSearch} />

                    <GamesSearchGlobal
                        isInitFocus
                        onCloseSearch={handlerCloseGamesSearch}
                    />
                </div>
            )}
        </>
    );
};
